import SubMenu from './submenu'
import UserSettings from './user-settings'

const classMap = {
  menu: 'js-menu',
  close: 'js-menu-close',
  expand: 'js-menu-expand',
  btnMenuItem: 'js-btn-menu-item',
  menuItem: 'js-hd-menu-item',
  submenu: 'js-submenu'
}

export default class Header {
  constructor() {
    this.menu = document.querySelector(`.${classMap.menu}`)
    this.body = document.querySelector('body')
    this.expand = document.querySelector(`.${classMap.expand}`)
    this.subMenu = new SubMenu()
    this.userSettings = new UserSettings()
  }

  mount() {
    // bind event handlers
    document.addEventListener('click', this.onHandlerExpandMenu.bind(this))
    document.addEventListener('click', this.onHandlerClose.bind(this))
    document.addEventListener('click', this.onHandlerMenu.bind(this))
    // document.addEventListener('mouseover', this.onHandlerMenu.bind(this))
    // document.addEventListener('mouseout', this.onHandlerMenu.bind(this))

    // mount sub-components
    this.subMenu.mount()
    this.userSettings.mount()
  }

  isMobile () {
    return window.innerWidth <= 768
  }

  /**
   * used only on desktop
   */
  toggleMenuItem(elMenuItem) {
    elMenuItem.classList.toggle('active')

    // toggle in aria-expanded
    const button = elMenuItem.querySelector(`.${classMap.btnMenuItem}`)
    const isExpanded = button.getAttribute('aria-expanded') === 'true'
    button.setAttribute('aria-expanded', !isExpanded);

    // toggle in aria-hidden
    const submenu = elMenuItem.querySelector(`.${classMap.submenu}`)
    submenu.setAttribute('aria-hidden', isExpanded);

    // open submenu in desktop
    this.subMenu.openFirstSubmenuItems(elMenuItem)
  }

  /**
   * used only on mobile
   */
  openMenuItem(elMenuItem) {
    elMenuItem.classList.add('active')
    // set aria-expanded is true
    const button = elMenuItem.querySelector(`.${classMap.btnMenuItem}`)
    button.setAttribute('aria-expanded', true);
    // set aria-hidden is false
    const submenu = elMenuItem.querySelector(`.${classMap.submenu}`)
    submenu.setAttribute('aria-hidden', false);
  }

  closeMenuItem(elMenuItem) {
    document.querySelectorAll(`.${classMap.menuItem}.active`).forEach(item => {
      if(item===elMenuItem) return
      item.classList.remove('active')
      // set aria-expanded is false
      const button = item.querySelector(`.${classMap.btnMenuItem}`)
      button.setAttribute('aria-expanded', false);
      // set aria-hidden is false
      const submenu = item.querySelector(`.${classMap.submenu}`)
      submenu.setAttribute('aria-hidden', true);
    })
  }

  /**
   * on mobile open the first menu item
   */
  openFirstMenuItem(){
    const fistItem = this.menu.querySelector(`.${classMap.menuItem}:first-child`)
    this.closeMenuItem(fistItem)
    this.openMenuItem(fistItem)
  }

  openExpandMenu(){
    this.menu.classList.add('is-open')
    this.body.classList.add('header-is-open')
    // set aria-expanded is true
    this.expand.setAttribute('aria-expanded', true)
  }

  closeExpandMenu(){
    this.menu.classList.remove('is-open')
    this.body.classList.remove('header-is-open')
    // set aria-expanded is false
    this.expand.setAttribute('aria-expanded', false)
  }

  /**
   * used only on mobile
   */
  onHandlerExpandMenu(event) {
    const clickedExpand = event.target.closest(`.${classMap.expand}`)
    if (!clickedExpand) return

    this.openExpandMenu()

    // mobile open fist submenu
    this.openFirstMenuItem()
  }

  /**
   * used only on mobile
   */
  onHandlerClose(event) {
    const clickedClose = event.target.closest(`.${classMap.close}`)
    if (!clickedClose) return

    // close all menu items
    this.closeMenuItem()
    this.closeExpandMenu()
  }

  onHandlerMenu(event){
    const clickedMenuItem = event.target.closest(`.${classMap.menuItem}`)
    // only desktop because of expand
    if (!clickedMenuItem && !this.isMobile()) {
      this.closeMenuItem()
      return
    }

    const clickedButton = event.target.closest(`.${classMap.btnMenuItem}`)
    if (clickedButton) {
      // get parent element
      const elMenuItem = clickedButton.closest(`.${classMap.menuItem}`)

      // close other menu items
      this.closeMenuItem(elMenuItem)

      // in desktop required toggle
      if(this.isMobile()){
        this.openMenuItem(elMenuItem)
      } else {
        this.toggleMenuItem(elMenuItem)
      }
    }
  }
}
